/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { FunctionComponent } from 'react'

import { EventTypeEnum } from '@builddocs/data-management'

import ActCreated from './actEvent/ActCreated'

import type { Notification } from '@builddocs/data-management'

interface OwnProps {
  notification: Notification
}

type NotificationItemCardProps = OwnProps

const NotificationItemCard: FunctionComponent<NotificationItemCardProps> =
  props => {
    const { notification } = props

    switch (notification.eventType) {
      case EventTypeEnum.ACT:
        return <ActCreated notification={notification} />
      default:
        return null
    }
  }

export default NotificationItemCard
